import { render, staticRenderFns } from "./Strategy.vue?vue&type=template&id=20abb0cd&scoped=true&"
import script from "./Strategy.vue?vue&type=script&lang=js&"
export * from "./Strategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20abb0cd",
  null
  
)

export default component.exports